import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import {
  getAccount,
  selectAccountDataState,
  selectAccountEmail,
  selectPersonalDetails,
} from '@bonanza-social/account';
import { formatDate } from '@bonanza-social/toolkit/utils';

export const useUserDetails = () => {
  const dispatch = useDispatch();
  const personalDetails = useSelector(selectPersonalDetails);
  const email = useSelector(selectAccountEmail);
  const accountDataState = useSelector(selectAccountDataState);

  const returnObj = useMemo(
    () => ({
      userDetails: {
        ...personalDetails,
        email,
        fullName: `${personalDetails?.firstName} ${personalDetails?.lastName}`,
        dob: formatDate(personalDetails?.birthDate || null),
      },
      accountDataState,
    }),
    [email, personalDetails, accountDataState],
  );

  useEffect(() => {
    if (accountDataState === 'idle') {
      dispatch(getAccount());
    }
  }, [accountDataState, dispatch]);

  return returnObj;
};

export default useUserDetails;
